"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerseSaleController = void 0;
var Result_1 = __importDefault(require("../../Result"));
var neko_1 = require("../../services/neko");
var errors_1 = require("./errors");
/**
 * Verse Sale controller. For handling all things Verse Sale related
 */
var VerseSaleController = /** @class */ (function () {
    function VerseSaleController() {
    }
    /**
     * Returns a timestamp of when the actual sale is starting.
     *
     * To be used for countdown
     *
     * @returns Timestamp
     */
    VerseSaleController.saleStarted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.token.saleStarted()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_GETTING_START_DATE)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets user agreement
     * @deprecated
     *
     * @returns userId and accepted
     */
    VerseSaleController.getTerms = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.token.getTerms()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_GET_TERMS)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @deprecated
     * Accepts verse user agreement
     */
    VerseSaleController.acceptTerms = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.token.acceptTerms()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_ACCEPT_TERMS)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets kyc status
     *
     * @returns TVerseKycStatus
     */
    VerseSaleController.getKycStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.token.getKycStatus()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_4 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_GET_KYC_STATUS)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets claim addresses
     * @deprecated
     *
     * @returns TVerseClaimAddressResponse
     */
    VerseSaleController.getClaimAddresses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.token.getClaimAddresses()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_5 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_GET_CLAIM_ADDRESSES)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Adds claim addresse
     * @deprecated
     */
    VerseSaleController.addClaimAddress = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.token.addClaimAddress(payload)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_6 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_ADD_CLAIM_ADDRESS)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates first claimAddresses
     * @deprecated
     */
    VerseSaleController.createClaimAddresses = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.token.createClaimAddresses(payload)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_7 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_CREATE_CLAIM_ADDRESSES)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets payments
     * @deprecated
     *
     * @returns TVersePaymentsResponse
     */
    VerseSaleController.getPayments = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.token.getPayments()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_8 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_GET_PAYMENTS)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get transaction status and information
     *
     * @returns TVerseTransactionResponse
     */
    VerseSaleController.getTransaction = function (coin, hash) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.token.getTransaction(coin, hash)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_9 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_GET_TRANSACTION)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get merkle proof from provided address
     *
     * @returns TVerseMerkleProofResponse
     */
    VerseSaleController.getMerkleProof = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var data, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, neko_1.neko.token.getMerkleProof(address)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(data)];
                    case 2:
                        error_10 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_GET_PROOF)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return VerseSaleController;
}());
exports.VerseSaleController = VerseSaleController;
